<template lang="pug">
div
  template(v-if="!showEditMode")
    .d-flex.align-center
      template(v-if="value")
        .d-flex.align-center
          .text-sm Tax
          v-btn.ml-2(v-if="isEditable" small icon @click="removeTax")
            v-icon(small) mdi-close
      template(v-else)
        .text-sm.font-semibold.underline.clickable(v-if="isEditable" @click="showEditMode = true") {{ $t('add_item', { item: $t('tax').toLowerCase() }) }}
        .text-sm(v-else) Tax
      v-spacer
      .text-sm.no-wrap(v-if="!hidePrice") {{ value | displayPrice }}
  template(v-else)
    v-row(no-gutters align="center")
      v-col
        .text-sm.flex-grow-1 Add tax
      v-spacer
      v-col.d-flex.align-center(cols="5")
        v-text-field.text-sm.round-xl(v-model.number="tax" autofocus placeholder="0.00" outlined dense type="number" :prefix="$currency.symbol" hide-details="auto" @blur="handleConfirm")
</template>

<script>
export default {
  props: {
    hidePrice: {
      type: Boolean
    },
    value: {
      type: Number,
      default: 0
    },
    parentData: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      showEditMode: false,
      tax: 0
    }
  },
  computed: {
    isEditable () {
      return this.parentData?.order_status !== 'archived' && this.parentData?.order_status !== 'completed' 
    }
  },
  methods: {
    removeTax () {
      this.$emit('input', 0)
    },
    handleConfirm () {
      const value = Math.round(this.tax * this.$currency.multiplier)
      this.$emit('input', value)
      this.tax = value
      this.showEditMode = false
    }
  },
}
</script>

<style lang="scss" scoped>
</style>